// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3lOTs","header":"PatientBlock_header__fLa31","label":"PatientBlock_label__2uBQT","option":"PatientBlock_option__3ReI3"};